// Edit homepage copy here — components read from this file.
export const WHY_DWG = {
  eyebrow: "Kenapa Dessy Wedding Group",
  title: "Satu tim untuk seluruh hari bahagia Anda",
  subtitle: "Tidak perlu koordinasi dengan banyak vendor. Dari makeup sampai dokumentasi, semuanya dikerjakan tim kami sendiri.",
  points: [
    {
      icon: "users",
      title: "Semua dari satu tim",
      body: "MUA, dekorasi, foto & video, WO, musik, dan attire adalah divisi kami sendiri — bukan vendor titipan. Koordinasi lebih rapi, risiko miskomunikasi lebih kecil.",
    },
    {
      icon: "award",
      title: "Berpengalaman sejak 2015",
      body: "Lebih dari 10 tahun menangani pernikahan di Garut, Bandung, dan sekitarnya — dari akad sederhana sampai resepsi ratusan tamu.",
    },
    {
      icon: "landmark",
      title: "Paham adat Sunda",
      body: "Siger Sunda, siraman, hingga upacara adat ditangani tim yang terbiasa dengan tradisinya, tanpa kehilangan sentuhan modern.",
    },
    {
      icon: "receipt",
      title: "Harga jelas sejak awal",
      body: "Isi dan harga paket bisa dilihat langsung di website. Mau paket lengkap atau vendor satuan, Anda yang tentukan.",
    },
  ],
  cta: { label: "Lihat Paket", to: "/paket-wedding-dwg" },
};

export const FAQ = {
  title: "Pertanyaan yang sering ditanyakan",
  items: [
    {
      q: "Bagaimana cara booking tanggal?",
      a: "Mulai dari konsultasi gratis untuk memilih paket. Setelah cocok, tanggal Anda dikunci dengan booking fee Rp1.000.000. Booking fee ini sudah termasuk dalam total harga paket.",
    },
    {
      q: "Bagaimana skema pembayarannya?",
      a: "Ada tiga tahap:",
      list: [
        "Booking fee Rp1.000.000 untuk mengunci tanggal",
        "DP 50% paling lambat 1 bulan sebelum acara",
        "Pelunasan paling lambat H-7 sebelum acara",
      ],
    },
    {
      q: "Bagaimana jika acara dibatalkan?",
      a: "Booking fee tidak dapat dikembalikan. Jika DP sudah dibayarkan, 50% dari DP akan dikembalikan.",
    },
    {
      q: "Apakah bisa pindah tanggal?",
      a: "Bisa. Pindah tanggal dapat dilakukan selama tanggal baru masih tersedia di jadwal kami. Hubungi tim kami secepatnya agar pilihan tanggal masih banyak.",
    },
    {
      q: "Apakah konsultasi berbayar?",
      a: "Tidak. Konsultasi gratis, bisa lewat form Konsultasi Online atau WhatsApp.",
    },
    {
      q: "Area mana saja yang dilayani?",
      a: "Garut, Bandung, dan sekitarnya. Untuk lokasi di luar area tersebut, silakan konsultasikan dulu — tim kami akan menginformasikan ketersediaan dan biaya tambahan jika ada.",
    },
    {
      q: "Bisa pesan vendor satuan saja?",
      a: "Bisa. Selain paket bundling, Anda bisa memilih layanan satuan seperti MUA saja, dekorasi saja, atau foto & video saja. Lihat di halaman Vendor & Harga.",
    },
    {
      q: "Apakah harga di website sudah final?",
      a: "Harga dapat berubah sewaktu-waktu. Harga yang berlaku adalah harga saat Anda melakukan booking.",
    },
    {
      q: "Kapan sebaiknya booking?",
      a: "Semakin awal semakin aman, terutama untuk tanggal favorit dan musim pernikahan, karena jumlah acara per tanggal terbatas.",
    },
  ],
  footnote: "Masih ada pertanyaan?",
  cta: { label: "Konsultasi Gratis", to: "/consultation" },
};

const faqAnswerText = (it) =>
  it.list ? `${it.a.replace(/:$/, "")}: ${it.list.join("; ")}.` : it.a;

export const faqJsonLd = () => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: FAQ.items.map((it) => ({
    "@type": "Question",
    name: it.q,
    acceptedAnswer: { "@type": "Answer", text: faqAnswerText(it) },
  })),
});
